/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_GeneralInputs */

const en_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const es_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const fr_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Général`)
};

const de_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

const ja_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的なサービス`)
};

const zh_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`综合常规服务`)
};

const ar_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عام`)
};

const id_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umum`)
};

const it_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generale`)
};

const ru_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общие услуги`)
};

const pt_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geral`)
};

const ko_val_general = /** @type {(inputs: Val_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반 서비스`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Val_GeneralInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_general = /** @type {((inputs?: Val_GeneralInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_GeneralInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_general(inputs)
	if (locale === "es") return es_val_general(inputs)
	if (locale === "fr") return fr_val_general(inputs)
	if (locale === "de") return de_val_general(inputs)
	if (locale === "ja") return ja_val_general(inputs)
	if (locale === "zh") return zh_val_general(inputs)
	if (locale === "ar") return ar_val_general(inputs)
	if (locale === "id") return id_val_general(inputs)
	if (locale === "it") return it_val_general(inputs)
	if (locale === "ru") return ru_val_general(inputs)
	if (locale === "pt") return pt_val_general(inputs)
	return ko_val_general(inputs)
});